import { useEffect, useRef } from 'react';

export function useDelayedResizeObserver(
	observeTargetRef: React.RefObject<HTMLDivElement>,
	resizeObserverCallback: ResizeObserverCallback,
	pollInterval: number = 100,
	additionalDeps: React.DependencyList = [],
) {
	const resizeObserverRef = useRef<ResizeObserver | null>(null);
	const pollIntervalRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		const observeDelayedTarget = () => {
			if (!observeTargetRef.current) {
				return;
			}

			// clear polling once target is ready
			if (pollIntervalRef.current) {
				clearInterval(pollIntervalRef.current);
				pollIntervalRef.current = null;
			}

			resizeObserverRef.current = new ResizeObserver(resizeObserverCallback);
			resizeObserverRef.current.observe(observeTargetRef.current);
		};

		// start polling for the target
		observeDelayedTarget(); // check immediately
		pollIntervalRef.current = setInterval(observeDelayedTarget, pollInterval);

		return () => {
			if (pollIntervalRef.current) {
				clearInterval(pollIntervalRef.current);
			}
			if (resizeObserverRef.current) {
				resizeObserverRef.current.disconnect();
			}
		};
	}, [...additionalDeps]); // eslint-disable-line react-hooks/exhaustive-deps
}
